<template>
  <v-container>
    <Table
      module="Quality"
      title="Quality Audits"
      :items="allAudits"
      :headers="headers"
      :totalItems="totalItems"
      :currentPagination="search"
    >
      <template v-slot:data="{props}">
        <td @click="handleRowClick(props)">{{localizeDate(props.item.dateCreated, true)}}</td>
        <td @click="handleRowClick(props)">{{ props.item.auditor ? props.item.auditor.name : "" }}</td>
        <td @click="handleRowClick(props)">{{ props.item.operator ? props.item.operator.name : "" }}</td>
        <td @click="handleRowClick(props)">{{ props.item.category }}</td>
        <td>
          <v-icon class="mr-2" small @click="editRow(props.item)">edit</v-icon>
          <v-icon small @click="deleteRow(props.item)">delete</v-icon>
        </td>
      </template>
    </Table>
    <Create v-model="createView" />
    <Audit
      v-model="auditView"
      :item="row"
      @handleNextItem="handleNextItem"
      @handlePrevItem="handlePrevItem"
    />
    <v-btn fab fixed bottom right icon color="secondary" @click="createView = true">
      <v-icon large>add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Table from "@/components/app/Table";
import Create from "@/components/audits/quality/Create";
import Audit from "@/components/audits/quality/Audit";
import LoginCheck from "@/mixins/LoginCheck";
import Common from "@/mixins/Common";

export default {
  name: "Quality",

  components: {
    Table,
    Create,
    Audit
  },

  data() {
    return {
      createView: false,
      auditView: false,
      row: [],
      allItems: [],
      search: {},
      headers: [
        { text: "Audit Date", value: "dateCreated" },
        { text: "Auditor", value: "auditor.name" },
        { text: "Operator", value: "operator.name" },
        { text: "Department", value: "category" },
        { text: "Actions", value: "actions", sortable: false }
      ]
    };
  },

  computed: {
    ...mapGetters({
      allAudits: "audits/getAllAudits",
      user: "app/getUser",
      totalItems: "audits/getTotalAudits"
    })
  },

  destroyed() {
    this.$store.commit("audits/setAllAudits", []);
    this.$store.commit("audits/setQuestions", []);
  },

  mixins: [LoginCheck, Common],

  methods: {
    handleRowClick(item) {
      item.totalItems = this.totalItems;
      item.index =
        item.search.page === 1
          ? item.index
          : item.index + (item.search.page - 1) * item.search.rowsPerPage;
      this.auditView = true;
      this.row = item;
      this.allItems = this.allAudits;
      this.search = item.search;
    },
    async handleNextItem(index) {
      let length = this.allItems.length - 1;
      let pageIndex =
        index - (this.search.page - 1) * this.search.rowsPerPage + 1;

      if (pageIndex <= length) {
        let nextIndex =
          index - (this.search.page - 1) * this.search.rowsPerPage + 1;
        this.row = {
          index: ++index,
          item: this.allItems[nextIndex],
          search: this.search,
          totalItems: this.totalItems
        };
      } else {
        this.allItems = await this.getPage(this.search, this.search.page + 1);
        this.row = {
          index: ++index,
          item: this.allItems[0],
          search: this.search,
          totalItems: this.totalItems
        };
      }
    },
    async handlePrevItem(index) {
      let pageIndex =
        index - (this.search.page - 1) * this.search.rowsPerPage + 1;
      if (pageIndex > 1) {
        let nextIndex =
          index - (this.search.page - 1) * this.search.rowsPerPage - 1;
        this.row = {
          index: --index,
          item: this.allItems[nextIndex],
          search: this.search,
          totalItems: this.totalItems
        };
      } else {
        this.allItems = await this.getPage(this.search, this.search.page - 1);
        this.row = {
          index: --index,
          item: this.allItems[this.allItems.length - 1],
          search: this.search,
          totalItems: this.totalItems
        };
      }
    },
    editRow(row) {
      this.createView = true;
      this.$store.commit("audits/setEditAudit", row);
    },
    async deleteRow(row) {
      if (
        this.user._groups.includes("Admins") ||
        this.user.displayName === row.auditor.name
      ) {
        let confirmText = `Are you sure you want to delete this? It can not be recovered!`;
        if (confirm(confirmText)) {
          await this.$store.dispatch("audits/delete", {
            module: "quality",
            id: row._id
          });
          await this.$store.dispatch("audits/getAllAudits", {
            rowsPerPage: 10,
            sortBy: "dateCreated",
            descending: true,
            page: 1,
            from: null,
            to: null,
            search: null,
            module: "quality"
          });
        }
      } else {
        window.alert(
          "You do not have permission to delete this. Please contact an Administrator or the Auditor."
        );
      }
    },
    getPage(search, page) {
      search.page = page;
      return this.$store.dispatch("audits/getAllAudits", search);
    }
  }
};
</script>

<style scoped>
>>> .v-table.theme--dark tr:hover {
  cursor: pointer;
}
</style>
